import React from 'react';
import './Steps.css';

const Education = ({ formData, setFormData, language = 'fr' }) => {
  const t = {
    title: language === 'fr' ? 'Formation' : 'Education',
    itemTitle: (i) => language === 'fr' ? `Formation ${i + 1}` : `Education ${i + 1}`,
    schoolLabel: language === 'fr' ? 'Établissement *' : 'Institution *',
    schoolPlaceholder: language === 'fr' 
      ? "Institut Préparatoire aux Études d'Ingénieurs de Monastir (IPEIM)"
      : "Preparatory Institute for Engineering Studies of Monastir (IPEIM)",
    degreeLabel: language === 'fr' ? 'Diplôme *' : 'Degree *',
    degreePlaceholder: language === 'fr' 
      ? "Cycle Préparatoire aux Études d'Ingénieur"
      : "Preparatory Cycle for Engineering Studies",
    startLabel: language === 'fr' ? 'Date de début *' : 'Start Year *',
    startPlaceholder: '2020',
    endLabel: language === 'fr' ? 'Date de fin *' : 'End Year *',
    endPlaceholder: '2022',
    removeBtn: language === 'fr' ? 'Supprimer' : 'Remove',
    addBtn: language === 'fr' ? '+ Ajouter une formation' : '+ Add Education'
  };

  const handleEducationChange = (index, field, value) => {
    const newEducation = [...formData.education];
    newEducation[index][field] = value;
    setFormData(prev => ({ ...prev, education: newEducation }));
  };

  const addEducation = () => {
    setFormData(prev => ({
      ...prev,
      education: [...prev.education, { school: '', degree: '', start: '', end: '' }]
    }));
  };

  const removeEducation = (index) => {
    const newEducation = formData.education.filter((_, i) => i !== index);
    setFormData(prev => ({ ...prev, education: newEducation }));
  };

  return (
    <div className="step-content">
      <h2>{t.title}</h2>
      
      {formData.education.map((edu, index) => (
        <div key={index} className="form-item">
          <div className="item-header">
            <h3>{t.itemTitle(index)}</h3>
            <button type="button" className="remove-btn" onClick={() => removeEducation(index)}>
              {t.removeBtn}
            </button>
          </div>

          <div className="form-grid">
            <div className="input-group full-width">
              <label>{t.schoolLabel}</label>
              <input
                type="text"
                value={edu.school}
                onChange={(e) => handleEducationChange(index, 'school', e.target.value)}
                placeholder={t.schoolPlaceholder}
                required
              />
            </div>

            <div className="input-group full-width">
              <label>{t.degreeLabel}</label>
              <input
                type="text"
                value={edu.degree}
                onChange={(e) => handleEducationChange(index, 'degree', e.target.value)}
                placeholder={t.degreePlaceholder}
                required
              />
            </div>

            <div className="input-group">
              <label>{t.startLabel}</label>
              <input
                type="text"
                value={edu.start}
                onChange={(e) => handleEducationChange(index, 'start', e.target.value)}
                placeholder={t.startPlaceholder}
                required
              />
            </div>

            <div className="input-group">
              <label>{t.endLabel}</label>
              <input
                type="text"
                value={edu.end}
                onChange={(e) => handleEducationChange(index, 'end', e.target.value)}
                placeholder={t.endPlaceholder}
                required
              />
            </div>
          </div>
        </div>
      ))}

      <button type="button" className="add-btn" onClick={addEducation}>
        {t.addBtn}
      </button>
    </div>
  );
};

export default Education;